import { createFileRoute } from '@tanstack/react-router'
import { CleverScorePage } from '@/pages/CleverScorePage'
import { ROUTES } from '@/constants/routeConstants.ts'

const App = () => {
  return <CleverScorePage />
}

export const Route = createFileRoute(ROUTES.CLEVERSCORE)({
  component: App,
})
